(function() {
  var SWIPER_SEL = '[data-el-video-swiper]';
  var TRIGGER_SEL = '[data-el-video-trigger]';
  var PLAYER_SEL = '[data-el-video-player]';
  var PLAY_BTN_SEL = '[data-el-video-play-btn]';

  function initSection(section) {
    var swiperEl = section.querySelector(SWIPER_SEL);
    if (!swiperEl || typeof Swiper === 'undefined') return;

    var nav = section.querySelector('.el-video-slider__nav');
    var prevEl = nav ? nav.querySelector('.swiper-button-prev') : null;
    var nextEl = nav ? nav.querySelector('.swiper-button-next') : null;
    var paginationEl = nav ? nav.querySelector('.swiper-pagination') : null;

    var elVideoSliderSwiper = new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1.333,
      spaceBetween: 16,
      breakpoints: {
        0: { slidesPerView: 1.333, spaceBetween: 12 },
        581: { slidesPerView: 2, spaceBetween: 16 },
        981: { slidesPerView: 4, spaceBetween: 16 }
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      },
      pagination: {
        el: paginationEl,
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active'
      },
      on: {
        slideChange: function() {
          section.querySelectorAll(PLAYER_SEL).forEach(function(video) {
            if (video.pause) video.pause();
          });
          section.querySelectorAll(PLAY_BTN_SEL).forEach(function(btn) {
            btn.classList.remove('is-hidden');
          });
        }
      }
    });

    section.querySelectorAll(TRIGGER_SEL).forEach(function(wrap) {
      var video = wrap.querySelector(PLAYER_SEL);
      var playBtn = wrap.querySelector(PLAY_BTN_SEL);
      if (!video || !playBtn) return;

      wrap.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          playBtn.classList.add('is-hidden');
        } else {
          video.pause();
          playBtn.classList.remove('is-hidden');
        }
      });
    });
  }

  function run() {
    document.querySelectorAll('.el-video-slider').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector && e.target.querySelector(SWIPER_SEL)) {
      initSection(e.target);
    }
  });
})();
